import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption } from '@/design-system/components/typography';
import { SxProp, View } from 'dripsy';
import _ from 'lodash';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { LayoutContext } from 'contexts/LayoutContext';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { IssueCardStackParamList } from './type';
import moment from 'moment-timezone';
import { CardIssueTypeFilters } from '../../options';

export interface IssueCardProps {
  onClose: () => void;
  data: any;
  onLayout: (event: any) => void;
  account: string;
  tab?: number;
  returnData?: any;
  refresh?: () => void;
}

export const IssueCardWebTwoScreen: React.FC<IssueCardProps> = (props) => {
  const { onClose, data, onLayout, account, tab, returnData, refresh } = props;
  const { t } = useTranslation('account-management');
  const layout = useContext(LayoutContext);
  const {
    topHeader,
    body,
    horizontalWrapper,
    textLabel,
    textDebitAmount,
    textTitle,
    textAtmPin,
    btn,
    textHeaderTitle,
    textHeaderSubTitle
  } = sxStyles;

  const navigation = useNavigation<NativeStackNavigationProp<IssueCardStackParamList>>();

  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View
      sx={{
        height: layout.isMobile ? '100%' : 'auto',
        width: layout.dimensions.width,
        maxWidth: layout.isMobile ? layout.dimensions.width : Math.min(500, layout.dimensions.width),
        backgroundColor: '$backgroundPrimary'
      }}
      onLayout={(event) => {
        onLayout(event);
      }}>
      <View sx={topHeader}>
        <Icon name="checkCircleBlue" height={90} width={90} />
        <H6 bold sx={textHeaderTitle}>
          {t('card-account-management::issue-card.instruction-form.title--new-instruction-placed')}
        </H6>
        <TextCaption sx={textHeaderSubTitle}>
          {t('card-account-management::issue-card.instruction-form.text--you-have-issued-a-new-card')}
        </TextCaption>
      </View>
      <View sx={body}>
        <View>
          <TextCaption sx={textTitle} semiBold>
            {t('card-account-management::issue-card.instruction-form.product-name')}
          </TextCaption>
          <H6 sx={textAtmPin}>{returnData?.product?.name || '-'}</H6>
        </View>
        <View>
          <TextCaption sx={textTitle} semiBold>
            {t('card-account-management::issue-card.instruction-form.card-number-last-four-digits')}
          </TextCaption>
          <H6 sx={textAtmPin}>{returnData.last4 || '-'}</H6>
        </View>
        <View>
          <TextCaption sx={textTitle} semiBold>
            {t('card-account-management::issue-card.instruction-form.text--embossed-name')}
          </TextCaption>
          <H6 sx={textAtmPin}>{returnData.embossedName}</H6>
        </View>
        <View>
          <TextCaption sx={textTitle} semiBold>
            {t('card-account-management::issue-card.instruction-form.expiry-date')}
          </TextCaption>
          <H6 sx={textAtmPin}>{`${returnData.expiryMonth || '-'}/${
            (returnData.expiryYear || '').substring((returnData.expiryYear?.length || 0) - 2 || 0) || '-'
          }`}</H6>
        </View>
        <View sx={horizontalWrapper}>
          <TextBody sx={textLabel}>{t('card-account-management::lock-card.text--instruction-time')}</TextBody>
          <TextBody sx={textDebitAmount}>{returnData?.instructionTime || instructionTime || '-'}</TextBody>
        </View>
        <UniButton
          sx={btn}
          labelSx={{ color: '$balck' }}
          label={t('card-account-management::general.button--close')}
          onPress={() => {
            refresh();
            navigation.getParent()?.goBack();
          }}
        />
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault',
    mt: '$10'
  },
  body: {
    minHeight: 200,
    minWidth: 500,
    px: 28,
    py: 28,
    gap: '$5'
  },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  btn: {
    width: '100%',
    height: 44
  },
  textHeaderTitle: {
    mb: '$2'
  },
  textHeaderSubTitle: {
    color: '$textPrimary'
  }
};
